export default __webpack_public_path__ + "static/media/sample_excel_file.3eae0d94.xlsx";